// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gArSX","option":"styles_option__GN3OK","active":"styles_active__2RHHp"};